import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import ReferenceForm from "../components/ReferenceForm";

export default class ReferencesStep extends TalentAppStep
{
    static path = '/references';
    static LastUpdatedMethod = 'lastUpdatedReferences';

    static HasRequirements = true;
    static ValidationMethodName = 'validateTalentReferences'
    /**
     * The title shown on the form
     */
    static StepTitle = 'References';
    static StepShortTitle = 'References';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = 'Please provide two references below from former clients or supervisors who can ' +
        'recommend your work. These references will not be contacted until you are in an interview process with a ' +
        'client and they ask to see them. At that point, our system will email your references and ask them to ' +
        'quickly confirm their recommendation based upon prior work.';
    /**
     * The start page info tile
     */
    static StepInfo = 'Add references';

    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Background';

    /**
     * show completion icon on sidebar
     */
    static NeedsCompletion = (user) => {
        return user.isOnTalentMarketplace() && !user.isTalentSupplierResource();
    };

    /**
     * show completion icon on sidebar
     */
    missingValidation() {
        if (this.props.authUser.isOnTalentMarketplace() && !this.props.authUser?.isTalentSupplierResource() && this.props.authUser?.talent_references?.length <= 1) {
            return ['You must submit at least 2 references']
        }
        return false;
    }

    /**
     * Show brief details for user
     */
     static ProfileSectionSummary = (user) => {
        if(!this.hasCompleted(user)) return false;
        return `${user.talent_references?.length} References`;
    };
    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        if (!user.validateTalentReferences()) {
            return this;
        }

        return false;
    };

    static hasCompleted(user) {
        return !user.isOnTalentMarketplace?.() || user.isTalentSupplierResource?.()
            || TB.filter(user.talent_references || [], i => TB.isDefined(i?.id)).length >= 2
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user, skipGoToNextStep = false) {
        let props = TB.pick(user,'talent_references');
        if (!skipGoToNextStep && !user.hasCompletedApplication() && user.isOnTalentMarketplace()
            && !user.isTalentSupplierResource?.() && props.talent_references?.length <= 1) {
            await TB.alert(
                'error',
                `Minimum # of References Required`,
                'You must submit at least 2 references before continuing.'
            )
            return false;
        }
        return props
    };

    /**
     * @param {User} user
     * @returns {Object}
     */
    static reviewMapping(user) {
        let review = {};

        TB.map(user.talent_references || [],(reference, index) => {
            let referenceInfo = {
                'Name': reference.first_name + ' ' + reference.last_name,
                'Email': reference.email,
            };
            if (reference?.linkedin_profile_url) {
                referenceInfo['LinkedIn'] = reference?.linkedin_profile_url;
            }
            review[`Reference #${index + 1}`] = referenceInfo;
        })

        return review;
    }
    /**
     * Are requirements optional
     *
     * @returns boolean
     */
    isRequirementOptional() {
        return !this.props.authUser.isOnTalentMarketplace?.() || this.props.authUser?.isTalentSupplierResource?.();
    }
    /**
     * Are requirements completed?
     *
     * @returns boolean
     */
    isRequirementComplete() {
        return !this.props.authUser.isOnTalentMarketplace() || this.props.authUser.isTalentSupplierResource() ||
            TB.filter(this.props.authUser?.talent_references || [], ref => !!ref?.id)?.length >= 2;
    }
    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return (!this.props.authUser.isOnTalentMarketplace() ||
            this.props.authUser.isTalentSupplierResource()) ? 'References are optional and not required.': 'At least 2 submitted references are required.';
    }

    /**
     * Render the form
     *
     * @returns {Form}
     */
    renderFormFooter() {
        return (
            <div className="pb-6">

                {this.renderChildForm({
                    displayName: 'References',
                    ChildFormComponent: ReferenceForm,
                    formProps:{
                        talent_references: {...this.props.user}?.talent_references || [],
                    },
                    userProp: 'talent_references'
                })}
            </div>
        );
    }
}